import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '@mui/material/styles';
import { Box, CircularProgress } from '@mui/material';

import useMediaQuery from '@mui/material/useMediaQuery';

const Home = lazy(() => import('../pages/Home'));
const Transactions = lazy(() => import('../pages/Transactions'));
const Accounts = lazy(() => import('../pages/Accounts'));
const Settings = lazy(() => import('../pages/Settings'));
const UserProfile = lazy(() => import('../pages/UserProfile'));
const AuthLayout = lazy(() => import('../components/layout/AuthLayout'));
const AppLayout = lazy(() => import('../components/layout/AppLayout'));
const PageSkeleton = lazy(() => import('../components/common/PageSkeleton'));
const Login = lazy(() => import('../pages/Auth/Login'));
const Register = lazy(() => import('../pages/Auth/Register'));
const ForgotPassword = lazy(() => import('../pages/Auth/ForgotPassword'));
const PrivateRoute = lazy(() => import('./PrivateRoute'));
const PublicRoute = lazy(() => import('./PublicRoute'));
const Notifications = lazy(() => import('../pages/Notifications'));
const Categories = lazy(() => import('../pages/Categories'));


const AuthRoutes = () => (
    <AuthLayout>
        <Suspense fallback={
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100%' }}>
                <CircularProgress />
            </Box>
        }>

            <Routes>
                <Route path="/login" element={<PublicRoute element={<Login />} />} />
                <Route path="/register" element={<PublicRoute element={<Register />} />} />
                <Route path="/forgot-password" element={<PublicRoute element={<ForgotPassword />} />} />
                <Route path="*" element={<Navigate to="/login" />} /> {/* Redirigir a login si no coincide ninguna ruta */}
            </Routes>
        </Suspense>
    </AuthLayout>
);

const AppRoutes = ({ toggleTheme, isDarkMode }) => { // Recibir las props aquí
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { currentUser } = useAuth();

    return (
        <Router>
            <Suspense fallback={<PageSkeleton />}>
                <Routes>
                    {currentUser ? null : <Route path="*" element={<AuthRoutes />} />}
                    <Route
                        path="/"
                        element={
                            currentUser ? (
                                <AppLayout toggleTheme={toggleTheme} isDarkMode={isDarkMode} /> // Pasar las props aquí
                            ) : (
                                <Navigate to="/login" />
                            )
                        }
                    >
                        <Route index element={<PrivateRoute element={<Home />} />} />
                        <Route path="accounts" element={<PrivateRoute element={<Accounts isMobile={isMobile} />} />} />
                        <Route path="accounts/groups" element={<PrivateRoute element={<Accounts isMobile={isMobile} />} />} />
                        <Route path="transactions" element={<PrivateRoute element={<Transactions isMobile={isMobile} />} />} />
                        <Route path="settings" element={<PrivateRoute element={<Settings />} />} />
                        <Route path="profile" element={<PrivateRoute element={<UserProfile isMobile={isMobile} />} />} />
                        <Route path="notifications" element={<PrivateRoute element={<Notifications />} />} />
                        <Route path="categories" element={<PrivateRoute element={<Categories isMobile={isMobile} />} />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </Suspense>
        </Router>
    );
};

export default AppRoutes;